import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';

import SubscriptionDetails from 'containers/subscriptions/subscription-details/SubscriptionDetails';
import InvestorsTable from './InvestorsTable';
import { ListContainer } from 'components';

const Investors = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route
                    path={`${path}/details/:userId/:subscriptionId`}
                    component={SubscriptionDetails}
                />
                <Route path={path} render={() => <InvestorsTable />} />
            </Switch>
        </ListContainer>
    );
};

export default Investors;
